(function () {
  if (window.__remBlairHoverSizesBound) return;
  window.__remBlairHoverSizesBound = true;

  var MOBILE_MAX = 989;
  var scrollRaf = null;

  function addVariantToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.disabled) return;

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var config =
      typeof fetchConfig === 'function'
        ? fetchConfig('javascript')
        : {
            method: 'POST',
            headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
          };

    config.method = 'POST';
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.headers.Accept = config.headers.Accept || 'application/javascript';
    delete config.headers['Content-Type'];

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', '1');

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart
          .getSectionsToRender()
          .map(function (section) {
            return section.id;
          })
          .join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    config.body = formData;
    button.classList.add('is-loading');
    button.setAttribute('aria-busy', 'true');

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl, config)
      .then(function (response) {
        return response.json();
      })
      .then(function (response) {
        if (response.status) {
          console.error(response.description || response.message || response);
          return;
        }

        if (typeof publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'card-hover-sizes',
            productVariantId: variantId,
            cartData: response,
          });
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else if (window.routes && window.routes.cart_url) {
          window.location = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
      });
  }

  function isMobileViewport() {
    return window.matchMedia('(max-width: ' + MOBILE_MAX + 'px)').matches;
  }

  function getSizeCards() {
    return Array.prototype.slice.call(document.querySelectorAll('.card-wrapper')).filter(function (card) {
      return card.querySelector('.card-hover-sizes');
    });
  }

  function clearScrollActive() {
    document.querySelectorAll('.card-wrapper.is-scroll-active').forEach(function (card) {
      card.classList.remove('is-scroll-active');
    });
  }

  // Activate only the product row closest to the vertical center of the screen
  function updateActiveRow() {
    if (!isMobileViewport()) {
      clearScrollActive();
      return;
    }

    var cards = getSizeCards();
    if (!cards.length) return;

    var viewportCenter = window.innerHeight / 2;
    var bestCard = null;
    var bestDist = Infinity;

    cards.forEach(function (card) {
      var rect = card.getBoundingClientRect();
      if (rect.bottom <= 0 || rect.top >= window.innerHeight) return;
      var cardCenter = rect.top + rect.height / 2;
      var dist = Math.abs(cardCenter - viewportCenter);
      if (dist < bestDist) {
        bestDist = dist;
        bestCard = card;
      }
    });

    if (!bestCard) {
      clearScrollActive();
      return;
    }

    // Only light up when that row is reasonably near mid-screen
    var nearCenter = bestDist < window.innerHeight * 0.4;
    var bestTop = bestCard.getBoundingClientRect().top;

    cards.forEach(function (card) {
      var sameRow = Math.abs(card.getBoundingClientRect().top - bestTop) < 48;
      card.classList.toggle('is-scroll-active', nearCenter && sameRow);
    });
  }

  function scheduleActiveRowUpdate() {
    if (scrollRaf) return;
    scrollRaf = requestAnimationFrame(function () {
      scrollRaf = null;
      updateActiveRow();
    });
  }

  document.addEventListener(
    'click',
    function (event) {
      var button = event.target.closest('.card-hover-sizes__btn');
      if (!button) return;

      // Always keep size/quick-add clicks from following the product link
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();

      if (!button.getAttribute('data-variant-id') || button.disabled) return;
      addVariantToCart(button);
    },
    true
  );

  window.addEventListener('scroll', scheduleActiveRowUpdate, { passive: true });
  window.addEventListener('resize', scheduleActiveRowUpdate);

  document.addEventListener('shopify:section:load', scheduleActiveRowUpdate);
  var grid = document.getElementById('ProductGridContainer') || document.getElementById('product-grid');
  if (grid && typeof MutationObserver !== 'undefined') {
    var moTimer = null;
    new MutationObserver(function () {
      clearTimeout(moTimer);
      moTimer = setTimeout(scheduleActiveRowUpdate, 100);
    }).observe(grid, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateActiveRow);
  } else {
    updateActiveRow();
  }
})();
